import React, { ReactElement } from 'react';

import { Col, Divider, Form, Layout, Row, TypographyText } from '@components/atoms';
import InputField from '@components/molecules/InputField';
import {
  ADDITIONAL_SYMPTOM_ANSWER,
  CONFIRM_COMMENT_1,
  CONFIRM_COMMENT_2,
  CONFIRM_PLACE_HOLDER,
  CONFIRM_TITLE,
  NOT_ANYMORE_ANSWER,
} from '@constants/text';
import { useReduxForm } from '@hooks/useReduxForm';

function MainSymptom(): ReactElement {
  const { form, formData, formFieldsError, validationChecker, setFormData } = useReduxForm('survey');
  const { additionalSymptomFlag } = formData;
  return (
    <Layout yzTypeLayout="SURVEY">
      <Row>
        <Col yzTypeCol="center">
          <TypographyText yzTypeTypographyText="title">{CONFIRM_TITLE}</TypographyText>
        </Col>
      </Row>
      <Divider margin={8} yzTypeDivider="TRANSPARENT_LITTLE_SPACE" />
      <Row>
        <Col yzTypeCol="center">
          <TypographyText yzTypeTypographyText="basic">{CONFIRM_COMMENT_1}</TypographyText>
        </Col>
      </Row>
      <Row>
        <Col yzTypeCol="center">
          <TypographyText yzTypeTypographyText="basic">{CONFIRM_COMMENT_2}</TypographyText>
        </Col>
      </Row>
      <Divider margin={7.5} yzTypeDivider="TRANSPARENT_LITTLE_SPACE" />
      <Row>
        <Col
          onClick={() => {
            setFormData({
              additionalSymptomFlag: false,
            });
          }}
          span={24}
          yzTypeCol={additionalSymptomFlag === false ? 'selected-onset-button' : 'onset-button'}
        >
          <TypographyText yzTypeTypographyText="basic">{NOT_ANYMORE_ANSWER}</TypographyText>
        </Col>
      </Row>
      <Divider margin={3} yzTypeDivider="TRANSPARENT_LITTLE_SPACE" />
      <Row>
        <Col
          onClick={() => {
            setFormData({
              additionalSymptomFlag: true,
            });
          }}
          span={24}
          yzTypeCol={additionalSymptomFlag ? 'selected-onset-button' : 'onset-button'}
        >
          <TypographyText yzTypeTypographyText="basic">{ADDITIONAL_SYMPTOM_ANSWER}</TypographyText>
        </Col>
        {additionalSymptomFlag && (
          <>
            <Divider margin={5} yzTypeDivider="TRANSPARENT_LITTLE_SPACE" />
            <Form
              form={form}
              initialValues={{ additionalSymptom: formData.additionalSymptom ?? '' }}
              labelAlign="left"
              style={{ width: '100%' }}
            >
              <InputField
                borderTop={false}
                componentArray={[
                  {
                    type: 'textArea',
                    yzTypeTextArea: 'surveyItem',
                    placeholder: CONFIRM_PLACE_HOLDER,
                    dataIndex: `additionalSymptom`,
                    formData,
                    onChange: (e: any) => {
                      setFormData(`additionalSymptom`, e);
                    },
                  },
                ]}
                formFieldsError={formFieldsError}
                validation={validationChecker}
              />
            </Form>
          </>
        )}
      </Row>
      <Divider margin={38} yzTypeDivider="TRANSPARENT_LITTLE_SPACE" />
    </Layout>
  );
}

export default MainSymptom;
